export function formatValueForTables(value: string, multiplier?: number) {
  let parsedValue = parseFloat(value);
  if (multiplier) {
    parsedValue *= multiplier;
  }
  if (parsedValue === 0) {
    return '0';
  } else if (parsedValue % 1 === 0) {
    return `${parsedValue}`;
  } else {
    const factor = Math.pow(10, 3);
    const truncatedValue = Math.floor(parsedValue * factor) / factor;
    return `${truncatedValue.toFixed(3)}`;
  }
}
